import { Form, Input, Radio } from "antd";
import * as React from "react";
import { SelectCatalog } from "src/business/catalog/SelectCatalog";
import { SelectRole } from "src/business/role/SelectRole/SelectRole";
import { SelectUser } from "src/business/user/SelectUser";
import {
  defaultWorkflowDestination,
  workflowDestinations,
  ZWorkflow,
} from "src/business/workflow/ZWorkflow";
import { classNames } from "src/common/classNames";
import { maxNameLength, rxName, rxNameMsg } from "src/common/rxName";
import { trimRequired } from "src/common/validationRules";
import { IdBox } from "src/components/IdBox";
import { ZOption } from "src/types";

import * as styles from "./WorkflowCardMainTab.module.less";

type PropsWorkflowCardMainTab = {
  hidden: boolean;
  isNew: boolean;
  initialData: ZWorkflow;
};

const fin = (key: keyof ZWorkflow) => key;

export const WorkflowCardMainTab: React.FC<PropsWorkflowCardMainTab> = (
  props,
) => {
  const { isNew, hidden, initialData } = props;
  const destOptions: ZOption[] = React.useMemo(
    () =>
      Object.entries(workflowDestinations).map(([value, label]) => ({
        value,
        label,
      })),
    [],
  );
  return (
    <div className={classNames([styles.frame, [hidden, styles.hidden]])}>
      <Form.Item
        name={fin("name")}
        label="Системное название"
        rules={[
          trimRequired(),
          { pattern: rxName, message: rxNameMsg() },
          { max: maxNameLength },
        ]}
      >
        <Input disabled={!isNew} maxLength={maxNameLength} allowClear />
      </Form.Item>
      <IdBox entity={initialData} />
      <Form.Item
        name={fin("displayName")}
        label="Отображаемое название"
        rules={[trimRequired(), { max: maxNameLength }]}
      >
        <Input maxLength={maxNameLength} allowClear />
      </Form.Item>
      <Form.Item name={fin("description")} label="Описание">
        <Input.TextArea allowClear />
      </Form.Item>
      <Form.Item
        label="Каталог"
        name={fin("catalog")}
        rules={[{ required: true }]}
      >
        <SelectCatalog disabled={!isNew} />
      </Form.Item>
      <Form.Item
        label="Участники (доступно создание рабочих версий)"
        name={fin("roles")}
        rules={[
          { required: true, message: "Необходимо добавить хотя бы одну роль" },
        ]}
      >
        <SelectRole multiple />
      </Form.Item>
      <Form.Item
        label="Владелец"
        name={fin("owner")}
        rules={[{ required: true }]}
      >
        <SelectUser />
      </Form.Item>
      <Form.Item label="Назначение" name={fin("destination")}>
        <Radio.Group
          defaultValue={defaultWorkflowDestination}
          options={destOptions}
          optionType="button"
        />
      </Form.Item>
    </div>
  );
};
